(function(){
"use strict";
/* ══ GripForge™ Offset Extension Wrench — page behaviour ═══════════════════
   Cart is INERT until the Shopify product exists. See CART_WIRING at the
   bottom: swap in the three pack-variant ids and it becomes real.

   NAMING: the page says "GripForge™ Offset Extension Wrench" — the exact words
   already printed on Julian's retail box. It deliberately does NOT say "Reach":
   "Tite-Reach" is an existing US brand in this same category and the trademark
   sweep has not been run. Box wording carries zero trademark risk.
   ═══════════════════════════════════════════════════════════════════════════ */

var $=function(s,c){return (c||document).querySelector(s)},
    $$=function(s,c){return [].slice.call((c||document).querySelectorAll(s))},
    money=function(n){return '$'+n.toFixed(2)};

/* ══ 2026-08-09 — WHAT THE AMAZON + KALODATA LINKS ACTUALLY GAVE US ═══════
   Julian sent both to fill the spec gaps. They do not fill them, and it is
   worth writing down exactly why so nobody tries again.

   KALODATA — GJANSH "1/2in Wrench Extend Rod" (id 1731127816184959403),
   TikTok Shop, 30 days 07/10–08/08/2026:
       price $99.98 · revenue $135.87k ($4.53k/day) · 1.36k units (45.3/day)
       100% VIDEO revenue · live revenue $0.00 · creator conversion 42.54%
       concentration (L30D) 71.7% · rating 4.5/5 · 8,052 in stock · 10% commission
       material named in the title: "Ni Cr Alloy Steel"
   Its ENTIRE product description is:
       "Versatile Solution / Alloy Steel Material / Increased Leverage /
        Portable Design / Enhanced Efficiency"
   Not one number. No torque, no length, no thickness, no adapter list. That is
   a $135k/month product with zero published specs — which is the whole reason
   this page's "we print the number" angle has something to be different from.

   AMAZON — ZONORAY BS-10T, $37.99, 4.2★ (29), 300+/month, #117 Socket Wrenches.
   It is a DIFFERENT TOOL from Julian's, and the specs must not be copied over:
       thickness  1.57"        vs Julian's 0.63"
       torque     100 N·m in the spec table, "up to 120 N·m" in the bullets
                               vs Julian's 72 Nm
       mechanism  "compact gear construction"   vs Julian's roller CHAIN
       adapters   5 listed / "7 adapters + 3 sockets" claimed  vs Julian's 4
       length     16.7"   ·  Cr-V steel  ·  weight 1.35 kg vs "3.31 lbs" in a bullet
   Three internal contradictions in one listing. Useful as proof for the FAQ,
   useless as a source of truth.

   SO THE REMAINING GAPS NEED ONE THING: the supplier's spec sheet for the unit
   Julian is actually buying (CJ / 1688 / AliExpress listing). Adapter sizes,
   overall length and body steel come from there or they stay red.

   TWO STRATEGIC READS worth acting on separately:
   1. $99.99 IS THE VALIDATED PRICE. GJANSH is doing 45 units/day at $99.98.
      Not a guess — the proven TikTok price point. The Amazon lane is a
      different market: $17–$64, direct comparable at $37.99. Do not let the
      page invite the Amazon comparison, and do not discount toward it.
   2. THE CATEGORY SELLS ON CREATOR VIDEO, NOT LIVE. 100% of GJANSH's $135.87k
      is video revenue, live is literally $0.00, and 71.7% concentration says a
      handful of creators carry it. That is a media plan, not a page change.
      Also note the Amazon listings market these FOR impact guns and drills.
      This page says hand tools only, which is correct at 72 Nm — and is
      probably why their review sections read the way they do.               */

/* ══ SINGLE SOURCE OF TRUTH — every published spec ════════════════════════
   Every number the page states lives here once. All of these come off
   Julian's own six creatives, so page and ads can never disagree.
   Anything he has NOT supplied is null and renders as a loud red flag.     */
var SPEC={
  /* CONFIRMED BY JULIAN 2026-08-09: both the torque rating and the thickness
     are correct as printed on the creatives. His earlier verbal "50 ft-lb" is
     superseded — 72 Nm / 53 ft-lb is the real figure. */
  torqueNm : 72,
  torqueFt : 53,      /* 72 Nm = 53.1 ft-lb */
  thickIn  : 0.63,
  thickMm  : 16,      /* 0.63in = 16.0mm */
  guarantee: 60,      /* days, money back. Julian 2026-08-09: the real policy is
                         SIXTY days, which supersedes both the 30-day figure in
                         MASTER-BRAND-CONTEXT.md and SUPPORT-BRIEF.md's "no
                         published guarantee". ⚠ It also means the gold shield on
                         PDP 1 ("30-DAY MONEY-BACK GUARANTEE") now UNDERSTATES
                         the offer. Safe, but worth re-rendering to 60. */
  drive    : '1/2"',
  /* adapter COUNT is per colourway now — see COLORS below */
  finish   : 'Zinc plated',
  mechanism: 'Sealed steel roller-chain drive',

  /* ── NOT SUPPLIED YET. Each renders as a red .tbd box on the page. ── */
  origin       : null,   /* country of origin */
  adapterList  : null,   /* the exact sizes, e.g. 1/4" · 3/8" · 1/2" · 3/8"->1/2" */
  adapterSteel : 'Chrome vanadium (Cr-V)',  /* stamped "CR-V" on the adapters in
                            his own PDP 6 creative — sourced from his asset, not
                            from a competitor listing. */
  steel        : null,   /* BODY / CHAIN steel — still unknown. Cr-V on the
                            adapters does not tell us what the body is made of. */
  lengthIn     : null,   /* overall length + how far it actually reaches */
  warrantyTerms: null    /* written terms. Tiers 2 and 3 promise a 5-year
                            warranty — that needs real terms behind it. The
                            60-day money-back guarantee is separate and is
                            confirmed (SPEC.guarantee). */
};
var tbd=function(hint){return '<span class="tbd">['+hint+']</span>';};
var fact=function(v,hint){return v==null?tbd(hint):v;};
var TQ=SPEC.torqueNm+' Nm ('+SPEC.torqueFt+' ft-lb)';
var GTEE=SPEC.guarantee+'-day money-back guarantee';

/* ══ GALLERY ══════════════════════════════════════════════════════════════
   Julian's six creatives are all 4:5, which is what .gal__stage expects.  */
/* ══ THE TWO COLOURWAYS ═══════════════════════════════════════════════════
   Same picker pattern as the trimmer's White/Silver, which is inherited whole
   from gf-v6.css (.gfcolors / .gfc), so there is no new CSS for it.

   ⚠ ONE THING TO LOOK AT, JULIAN: these two photo sets do not obviously show
   the same tool in two anodisings. The silver set's hero is a telescoping shaft
   with a quick-release ratchet head and a black rubber grip; the orange set is
   a flat bar with chrome ends and a square drive at each end. If they are two
   different products, selling them as "colours" of one is the not-as-described
   risk we have been avoiding all along, and they should be two separate
   products instead. If it is genuinely the same casting in two finishes, this
   is exactly right. Your sourcing call — the page is built either way.        */
var SHARED_MEDIA=[
  ['hero',    'GripForge Offset Extension Wrench with its retail box and the socket adapter set'],
  ['kit',     'What comes in the box: the wrench, the adapter set and the retail box'],
  ['chain',   'Cutaway of the sealed steel roller-chain drive, rated to 72 Nm / 53 ft-lb'],
  ['tight',   'Working a bolt behind an alternator in a packed engine bay — 0.63 inches thick'],
  ['rotation','A full turn on the bolt with the handle turning out in open air'],
  ['oldnew',  'Straining with an open-end wrench versus turning the same bolt with the GripForge wrench']
];
/* The gallery video is the `machine` clip, and it shows the CHROME/telescoping
   tool — i.e. the Max. It is deliberately NOT in the 2.0's carousel: slide 3
   would then show a tool that is not the one selected, which is the same
   wrong-photo-for-the-variant problem Julian caught on the trimmer's cart
   thumbnail. If the 2.0 should have a video here too, it needs its own footage.
   Sits at index 2 = the third slide, as asked.                              */
function mediaFor(dir, withVideo){
  var C=CO();
  if(C.mediaList) return C.mediaList.slice();   /* theme-supplied, already ordered */
  var out=SHARED_MEDIA.map(function(m){return {t:'img', src:dir+m[0]+'.jpg', alt:m[1]};});
  if(withVideo) out.splice(2,0,{t:'vid', src:'vid/machine.mp4', poster:'vid/poster-machine.jpg',
    alt:'The wrench being used on a machine', sound:true});
  return out;
}
/* ══ FREE GIFTS ═══════════════════════════════════════════════════════════
   Reuses the real warranty emblems already on GripForge's CDN.

   NOTE — deliberately NO "FREE Express Shipping" gift, unlike the trimmer
   bundles. Every GripForge order already ships free and the promo bar says so,
   so dangling it as a tier-2 unlock is the fake gate Julian told me to stop
   using. Every gift below is something the shopper genuinely does not get at
   the tier beneath it.                                                      */
var CDN='https://cdn.shopify.com/s/files/1/0804/8554/8286/files/';
var TRASH='<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">'+
  '<path fill="currentColor" d="M9 3h6a1 1 0 0 1 1 1v1h4v2H4V5h4V4a1 1 0 0 1 1-1Zm1 2h4V4h-4v1ZM6 9h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 9Zm4 2v9h1v-9h-1Zm3 0v9h1v-9h-1Z"/></svg>';
var IMG_PROT='https://gripforgeshop.com/cdn/shop/files/checkmark_and_time-removebg-preview.png',
    IMG_WTY ='https://gripforgeshop.com/cdn/shop/files/hf_20260419_190148_9e72e7aa-ef87-4aee-bddf-75732cf7b82d-removebg-preview.png';
/* The trimmer page's four gift emblems, retitled for this SKU. Same Kaching
   images, so the two pages look like one brand. */
var GIFT={
  ship :{t:'FREE Express Shipping',              img:CDN+'Kaching-Bundles-images-removebg-preview.png'},
  w5   :{t:'FREE 5-Year Warranty',               img:CDN+'Kaching-Bundles-hf_20260418_181258_b758e28a-d8e8-4873-9f74-fd0af75678a6-removebg-preview.png'},
  life :{t:'FREE Lifetime Warranty', key:'wty',  img:IMG_WTY},
  ebook:{t:'FREE "Tight Space Repair Guide"',     img:'img/ebook.png'}
};
/* TWO THINGS SOMEBODY HAS TO ACTUALLY DO, or these become broken promises:

   1. "FREE EXPRESS SHIPPING" only works if tiers 2-3 genuinely ship FASTER.
      Every order already ships free and the promo bar says so on the same
      screen, so the gift cannot be the "free" part — it has to be the
      "express" part. This is the brand's sorest point already: the public
      Trustpilot reviews are largely about 30-day transit. If fulfilment does
      not actually expedite these, it is the one promise this audience punishes
      hardest. Either wire a faster service for tiers 2-3, or retitle it.

   2. THE eBOOK COVER EXISTS, THE eBOOK DOES NOT. Julian supplied the cover
      art (img/ebook.png) on 2026-08-09: "THE TIGHT SPACE REPAIR GUIDE — 37
      bolts every mechanic dreads, and how to reach them." The cover now sets
      the spec: it has to contain THIRTY-SEVEN bolts, each with how to reach
      it. That is a real writing job and a real delivery mechanism (Klaviyo
      post-purchase email is the cheap route). A digital gift IS deliverable,
      unlike a physical one — but only once the PDF is written. Until then the
      tier-3 card is promising a document that does not exist.                */
/* THREE THINGS I DELIBERATELY DID NOT PUT IN THIS TABLE:

   1. "FREE Lifetime Warranty". The trimmer's tier 3 uses it, but
      MASTER-BRAND-CONTEXT.md:63 is explicit — "5-YEAR WARRANTY — NEVER
      'lifetime.' NEVER '2-year.' Five years. This is the single most repeated
      copy error. Check it every time." The brand doc wins. Five years only.
      (The live trimmer page carries the same violation — worth a look.)

   2. "FREE Express Shipping". Every GripForge order already ships free and the
      promo bar says so. Dangling it as a tier unlock is the fake gate you told
      me to stop using.

   3. "FREE 2nd Adapter Set". It was arithmetically fine but operationally
      fake: on the live trimmer page every gift is COPY ONLY — no $0 line item,
      no discount function, nothing reaches the cart. A warranty can survive
      that because it is a promise. A second adapter set cannot: somebody has
      to physically put it in the box. Not shipping a promise nobody fulfils. */

/* ══ THE OFFER ════════════════════════════════════════════════════════════
   Two ladders, one per colourway, both Julian's numbers verbatim.

   SILVER — compare-at is his: $139.99 / $199.98 / $299.99.
   ORANGE — he gave the selling prices and the two labels. Setting a single RRP
   of $99.99 makes both labels ARITHMETICALLY EXACT rather than approximate,
   which is the same trick the trimmer page uses (compare-at = RRP x qty):
       qty 2: $99.99 is exactly 50% of 2 x $99.99 = $199.98  -> "BOGO 50% OFF" ✓
       qty 3: $139.99 vs 2 x $69.99 = $139.98 — you pay for two and get three,
              off by one cent                                -> "Buy 2 Get 1 FREE" ✓
   Both labels therefore say what the maths does, which is the whole point of
   this page. Per-unit strings stay hardcoded — never compute a displayed price.

   ⚠ The silver ladder's known wart is unchanged: its marginal 3rd wrench costs
   $50 while the 2nd costs $45. ORANGE does NOT have that problem — its 2nd unit
   is $30.00 and its 3rd is $40.00... which is the same shape. Flagged, not
   silently "fixed": these are your prices.                                    */
var TIERS_SILVER=[
  {q:1,price:99.99, was:139.99, each:'$99.99 each', label:'Save $40 Instantly!',
   badge:'Starter Special', name:'One Wrench',
   sub:'Get on the bolt that stopped you today.', gifts:[]},
  {q:2,price:144.99,was:199.98, each:'$72.50 each', label:'Save $54.99 Instantly!',
   badge:'Most Popular', name:'Two-Wrench Bundle',
   sub:'One in the truck. One in the shop.', gifts:[GIFT.ship,GIFT.w5]},
  {q:3,price:194.99,was:299.99, each:'$65.00 each', label:'Save $105 Instantly!',
   badge:'Best Value', name:'Three-Wrench Bundle',
   sub:'Truck, shop, trailer — or one to hand your brother.',
   gifts:[GIFT.ship,GIFT.life,GIFT.ebook]}
];
var TIERS_ORANGE=[
  {q:1,price:69.99, was:99.99,  each:'$69.99 each', label:'Save $30 Instantly!',
   badge:'Starter Special', name:'One Wrench',
   sub:'Get on the bolt that stopped you today.', gifts:[]},
  {q:2,price:99.99, was:199.98, each:'$50.00 each', label:'BOGO 50% OFF',
   badge:'Most Popular', name:'Two-Wrench Bundle',
   sub:'One in the truck. One in the shop.', gifts:[GIFT.ship,GIFT.w5]},
  {q:3,price:139.99,was:299.97, each:'$46.66 each', label:'Buy 2 Get 1 FREE',
   badge:'Best Value', name:'Three-Wrench Bundle',
   sub:'Truck, shop, trailer — or one to hand your brother.',
   gifts:[GIFT.ship,GIFT.life,GIFT.ebook]}
];

var COLORS={
  /* `name` must stay byte-identical to the Shopify option value, or the cart
     line and the order confirmation will say something the page never said.
     Shopify option "Model" = "Offset Extension Max" / "Offset Extension 2.0". */
  silver:{key:'silver', name:'Offset Extension Max', short:'Max', swatch:'#c6c9ce', dir:'img/', video:true,
          tiers:TIERS_SILVER, from:99.99, adapters:4,
          /* ⚠ its PDP 6 headline says 4 adapters while its hero photographs 5 */
          adapterNote:'4-vs-5 unresolved on the silver creatives'},
  orange:{key:'orange', name:'Offset Extension 2.0', short:'2.0', swatch:'#e2701a', dir:'img/orange/',
          tiers:TIERS_ORANGE, from:69.99, adapters:5,
          /* its two creatives agree on 5, so 5 is what the page states */
          adapterNote:'both orange creatives say 5'}
};

/* ══ THEME OVERRIDE ═══════════════════════════════════════════════════════
   On the Shopify theme, sections/gf-wrench.liquid emits window.GF_WRENCH from
   the real products — variant ids, prices and media URLs off the Shopify CDN.
   When present it wins, so a photo or price changed in the admin shows up here
   with no code edit. Absent (the localhost prototype) the hardcoded values are
   used, so one file serves both.

   applyCFG() is a FUNCTION, called after VARIANT is defined further down, not an
   inline block up here. `var` hoists the declaration but not the assignment, so
   running this at the top made VARIANT undefined and the whole script died on
   "Cannot set properties of undefined (setting 'silver')" — taking the entire
   page render with it. Same trap as the harness variable on the trimmer page.  */
var CFG = (typeof window!=='undefined' && window.GF_WRENCH) || null;
function applyCFG(){
  if(!CFG) return;
  /* theme asset URLs for the few images that are not product media */
  if(CFG.assets && CFG.assets.ebook) GIFT.ebook.img=CFG.assets.ebook;
  if(!CFG.models) return;
  Object.keys(COLORS).forEach(function(k){
    var m=CFG.models[k], C=COLORS[k];
    /* A model Liquid could not see — e.g. still a DRAFT product, which
       all_products does not expose — arrives as empty strings and empty arrays.
       Mark it unavailable and leave it out of the picker rather than offering a
       colourway that cannot be bought. */
    var ok = !!(m && m.variants && Object.keys(m.variants).length);
    C.available = ok;
    if(!ok) return;
    if(m.name) C.name=m.name;                       /* must equal the Shopify title */
    if(m.media && m.media.length){
      /* Shopify has no way to say "this video is the gallery one", so the rule
         is: the gallery shows every image plus the FIRST video, and the video row
         further down shows ALL of them. Without this, uploading the 2nd and 3rd
         clips as product media put all three into the carousel as well. */
      var seenVid=false;
      C.mediaList=m.media.filter(function(x){
        if(x.t!=='vid') return true;
        if(seenVid) return false;
        seenVid=true; return true;
      });
    }
    VARIANT[k]=m.variants;
    if(m.tiers && m.tiers.length){                  /* Shopify owns the price */
      m.tiers.forEach(function(t,i){
        if(C.tiers[i] && t && t.price){
          C.tiers[i].price=t.price;
          C.tiers[i].was = (t.was && t.was>t.price) ? t.was : 0;
        }
      });
      C.from=m.tiers[0].price;
    }
  });
  /* Preselect the model whose product page this actually is. */
  if(CFG.current && COLORS[CFG.current]) state.color=CFG.current;
  /* if the selected model turned out to be unavailable, fall back to one that is */
  if(COLORS[state.color] && COLORS[state.color].available===false){
    var first=Object.keys(COLORS).filter(function(k){return COLORS[k].available!==false})[0];
    if(first) state.color=first;
  }
}
function modelKeys(){
  return Object.keys(COLORS).filter(function(k){return COLORS[k].available!==false});
}

function CO(){ return COLORS[state.color]||COLORS.silver; }
function TIERS_(){ return CO().tiers; }

/* what the NEXT tier unlocks — a real gate, unlike a free-shipping one */
function unlockMsg(){
  var t=T();
  if(t.q===1) return '<b>'+money(TIERS_()[1].price-TIERS_()[0].price)+'</b> more adds a second wrench and '+
                     '<b>2 free gifts</b>';
  if(t.q===2) return '✓ 2 free gifts unlocked — <b>'+money(TIERS_()[2].price-TIERS_()[1].price)+
                     '</b> more adds a third wrench and upgrades you to <b>3 gifts including the '+
                     'Lifetime Warranty</b>';
  return '🎁 <b>All 3 free gifts unlocked</b> — and the best price per wrench';
}
/* the two paid add-ons, both already live Shopify products */
var UPSELL=[
  {key:'prot',n:'Shipping Protection',s:'Covers loss, theft and damage in transit',p:3.99,img:IMG_PROT},
  {key:'wty', n:'Lifetime Warranty',  s:'Free replacement if it ever fails',      p:4.99,img:IMG_WTY}
];
var PROT=3.99, WTY=4.99;

var state={tier:1,color:'silver',prot:false,wty:false,added:false};
/* is this add-on already free at the selected tier? */
/* Only the Lifetime Warranty gift maps onto a paid upsell (tier 3). Express
   Shipping is a SPEED upgrade and Shipping Protection is loss/theft/damage
   INSURANCE — different things, so Protection stays purchasable at every tier.
   At tier 2 the free gift is the 5-year warranty, so the $4.99 lifetime upsell
   is still a real upgrade there. */
function isFree(key){
  return T().gifts.some(function(g){return g.key===key});
}
var T=function(){var L=TIERS_();return L.filter(function(x){return x.q===state.tier})[0]||L[0]};

/* ── trust marquee — every item is a fact stated elsewhere on this page ── */
var MQ=['Rated to '+TQ+' — printed, not hidden','Free shipping on every order',
        'Only '+SPEC.thickIn+'" thick',SPEC.guarantee+'-day money-back guarantee',
        'Works with the breaker bar you already own','Real return address, real support inbox'];
var mq=$('#mq1');
if(mq){var g='<div class="mq__grp">'+MQ.map(function(x){return '<span>'+x+'</span>'}).join('')+'</div>';
  mq.innerHTML=g+g;}

/* ── gallery ────────────────────────────────────────────────────────────
   Rebuildable, because switching colourway swaps all six photos. Arrows, dots,
   swipe and the thumb strip are the trimmer's rig; one go() drives all of them.
   Thumb strip is hidden below 760px (reach.css) — you swipe instead.        */
var stage=$('#stage'), trail=$('#trail'), dots=$('#dots'), gi=0, gImgs=[], MEDIA=[];
function drawGallery(keepIndex){
  if(!stage||!trail) return;
  MEDIA=mediaFor(CO().dir, CO().video);
  gi=Math.min(keepIndex||0, MEDIA.length-1);
  /* Wipe images AND videos AND the sound button — the arrows and the dots
     container are the only siblings we keep. Wiping just 'img' left the <video>
     behind on every rebuild, so switching model stacked a stale video on the
     stage and the slide count crept up (7 -> 8) each time. */
  $$('img,video,#galSnd',stage).forEach(function(el){el.remove();});
  /* Prepended as ONE block so they land in MEDIA order and stay underneath the
     arrows and dots. insertBefore(im, firstChild) in a loop reverses them, which
     silently mismatched every thumb and dot against the stage once already. */
  stage.insertAdjacentHTML('afterbegin', MEDIA.map(function(m,i){
    if(m.t==='vid') return '<video src="'+m.src+'" poster="'+m.poster+'" muted loop '+
      'playsinline preload="none" disablepictureinpicture'+(i===gi?' class="on"':'')+'></video>';
    return '<img src="'+m.src+'" alt="'+m.alt+'"'+(i===gi?' class="on"':' loading="lazy"')+'>';
  }).join(''));
  /* the sound toggle rides on the stage, not on each slide, so it can sit above
     whichever media is showing */
  if(MEDIA.some(function(m){return m.t==='vid'&&m.sound}) && !$('#galSnd')){
    stage.insertAdjacentHTML('beforeend',
      '<button class="vid__snd gal__snd" id="galSnd" type="button" aria-pressed="false" '+
      'aria-label="Turn sound on" hidden>🔇</button>');
    $('#galSnd').addEventListener('click',function(e){
      e.stopPropagation();
      var v=$('#stage video'); if(!v) return;
      v.muted=!v.muted;
      this.textContent=v.muted?'🔇':'🔊';
      this.setAttribute('aria-pressed',String(!v.muted));
      this.setAttribute('aria-label',v.muted?'Turn sound on':'Turn sound off');
      if(!v.muted&&v.paused) v.play().catch(function(){});
    });
  }
  gImgs=$$('img,video',stage);
  trail.innerHTML=MEDIA.map(function(m,i){
    return '<button type="button" data-i="'+i+'" aria-label="View '+(m.t==='vid'?'video':'image')+
      ' '+(i+1)+'" aria-current="'+(i===gi)+'">'+
      '<img src="'+(m.t==='vid'?m.poster:m.src)+'" alt="" loading="lazy">'+
      (m.t==='vid'?'<span class="play">▶</span>':'')+'</button>';
  }).join('');
  if(dots) dots.innerHTML=MEDIA.map(function(m,i){
    return '<button type="button" data-i="'+i+'" aria-label="Go to image '+(i+1)+
      '" aria-current="'+(i===gi)+'"></button>';
  }).join('');
  $$('#trail button,#dots button').forEach(function(b){
    b.addEventListener('click',function(){go(+b.dataset.i)});
  });
}
function go(n){
  if(!MEDIA.length) return;
  gi=(n+MEDIA.length)%MEDIA.length;
  gImgs.forEach(function(el,k){
    var on=k===gi;
    el.classList.toggle('on',on);
    if(el.tagName==='VIDEO'){
      if(on){ el.preload='auto'; var p=el.play(); if(p&&p.catch) p.catch(function(){}); }
      else { el.pause(); el.muted=true; }
    }
  });
  /* the sound button only exists while the video slide is the one showing */
  var sb=$('#galSnd');
  if(sb){
    var isVid=(MEDIA[gi]||{}).t==='vid';
    sb.hidden=!isVid;
    if(!isVid){ sb.textContent='🔇'; sb.setAttribute('aria-pressed','false'); }
  }
  $$('#trail button').forEach(function(b,k){b.setAttribute('aria-current',k===gi?'true':'false')});
  $$('#dots button').forEach(function(b,k){b.setAttribute('aria-current',k===gi?'true':'false')});
}
if(stage&&trail){
  stage.addEventListener('click',function(e){
    if(e.target.tagName!=='VIDEO') return;      /* arrows and the sound button handle themselves */
    var v=e.target;
    if(v.paused){ v.preload='auto'; v.play().catch(function(){}); } else v.pause();
  });
  var gp=$('#gPrev'), gn=$('#gNext');
  if(gp) gp.addEventListener('click',function(){go(gi-1)});
  if(gn) gn.addEventListener('click',function(){go(gi+1)});
  /* swipe — same 44px threshold as the trimmer */
  var sx=null;
  stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
  stage.addEventListener('touchend',function(e){
    if(sx===null) return;
    var dx=e.changedTouches[0].clientX-sx;
    if(Math.abs(dx)>44) go(gi+(dx<0?1:-1));
    sx=null;
  },{passive:true});
}

/* ── colourway picker — the trimmer's White/Silver pattern ───────────────
   .gfcolors / .gfc come straight from gf-v6.css, including the selected state
   and the mobile ordering, so this adds no CSS. Each card shows the swatch, the
   name and that colourway's entry price, so the choice is priced up front.   */
function drawColors(){
  var c=$('#gfColors'); if(!c) return;
  var keys=modelKeys();
  /* one model available = nothing to choose; hide the picker and its label
     instead of showing a single dead option */
  var lbl=$('.offer__t--col');
  if(keys.length<2){ c.innerHTML=''; c.hidden=true; if(lbl) lbl.hidden=true; return; }
  c.hidden=false; if(lbl) lbl.hidden=false;
  c.innerHTML=keys.map(function(k){
    var C=COLORS[k], on=k===state.color;
    return '<button class="gfc gfc--long'+(on?' on':'')+'" data-c="'+k+'" type="button" '+
      'role="radio" aria-checked="'+on+'">'+
      '<span class="gfc__sw" style="background:'+C.swatch+'"></span>'+
      '<span class="gfc__t"><span class="gfc__n">'+C.name+'</span>'+
      '<span class="gfc__p">from '+money(C.from)+'</span></span></button>';
  }).join('');
  $$('.gfc',c).forEach(function(el){
    el.addEventListener('click',function(){
      if(state.color===el.dataset.c) return;
      state.color=el.dataset.c;
      /* Tier selection carries over, but clamp it in case a colourway ever has
         fewer tiers than the other. */
      if(!TIERS_().some(function(t){return t.q===state.tier})) state.tier=1;
      /* specs and the FAQ both embed the adapter count, which is per colourway
         (silver states 4, orange states 5) — they must rebuild too, or the page
         keeps showing the previous colour's spec. */
      drawColors(); drawGallery(0); drawBundles(); drawAddons();
      drawSpecs(); drawFaq(); drawTotal(); drawRender();
    });
  });
}

/* ── bundle cards ──────────────────────────────────────────────────────── */
var bx=$('#bundles');
/* Structure is the trimmer's, element for element, so both pages inherit the
   identical .bnd sizing from gf-v6.css: ribbon, radio + name/sub/label in
   .bnd__mid, price stack in .bnd__px using <b>/<s>/<em>, then the gift pills.
   No custom card CSS on this page at all — that is what keeps the boxes the
   same size as the trimmer's instead of a little bigger. */
function drawBundles(){
  if(!bx) return;
  bx.innerHTML=TIERS_().map(function(t){
    var on=t.q===state.tier;
    return '<div class="bnd" data-q="'+t.q+'" data-on="'+(on?1:0)+'" role="radio" tabindex="0" aria-checked="'+on+'">'+
      '<span class="bnd__ribbon">'+t.badge+'</span>'+
      '<div class="bnd__row"><span class="bnd__radio"></span>'+
        '<span class="bnd__mid"><span class="bnd__name">'+t.name+'</span>'+
          (t.sub?'<span class="bnd__sub">'+t.sub+'</span>':'')+
          '<span class="bnd__lbl">'+t.label+'</span></span>'+
        '<span class="bnd__px"><b>'+money(t.price)+'</b>'+
          (t.was?'<s>'+money(t.was)+'</s>':'')+
          '<em>'+t.each+'</em></span>'+
      '</div>'+
      (t.gifts.length?'<div class="bnd__gifts">'+t.gifts.map(function(gg){
        return '<span><img src="'+gg.img+'" alt="">+ '+gg.t+'</span>'}).join('')+'</div>':'')+
    '</div>';
  }).join('');
  $$('.bnd',bx).forEach(function(el){
    var pick=function(){state.tier=+el.dataset.q; drawBundles(); drawAddons(); drawTotal(); drawRender();};
    el.addEventListener('click',pick);
    el.addEventListener('keydown',function(e){
      if(e.key===' '||e.key==='Enter'){e.preventDefault();pick();}
    });
  });
}

/* ── add-ons — same two the trimmer page sells, same prices ─────────────
   A row goes FREE + disabled when the selected tier already gives it, so the
   card and the cart can never disagree about what was promised.            */
function drawAddons(){
  var a=$('#addons'); if(!a) return;
  a.innerHTML=UPSELL.map(function(u){
    var free=isFree(u.key), on=free||state[u.key];
    return '<button class="addon" data-k="'+u.key+'" data-on="'+(on?1:0)+'" type="button"'+
      (free?' disabled aria-disabled="true"':'')+'>'+
      '<img src="'+u.img+'" alt="">'+
      '<span class="a-t">'+u.n+' <small>'+u.s+'</small></span>'+
      '<span class="a-p">'+(free?'<b class="a-free">FREE</b>':'+'+money(u.p))+'</span>'+
      '<span class="chk" role="checkbox" aria-checked="'+(on?'true':'false')+'">✓</span>'+
    '</button>';
  }).join('');
  $$('.addon',a).forEach(function(el){
    if(el.disabled) return;
    el.addEventListener('click',function(){
      state[el.dataset.k]=!state[el.dataset.k]; drawAddons(); drawTotal();
    });
  });
}

/* ── totals ────────────────────────────────────────────────────────────── */
function drawTotal(){
  var t=T();
  var addProt=state.prot&&!isFree('prot'), addWty=state.wty&&!isFree('wty');
  var now=t.price+(addProt?PROT:0)+(addWty?WTY:0);
  var was=t.was  +(addProt?PROT:0)+(addWty?WTY:0);
  /* .savepill was rendering as a bare 20x10 orange blob next to the struck
     price: TIERS lost its `save` field when the labels moved onto the cards, so
     this was setting empty text into an element that still has pill padding and
     a 999px radius. It now carries the real figure, and hides if there is ever
     nothing to say. */
  var saveAmt=t.was?t.was-t.price:0;
  [['#tNow',money(now)],['#atcPrice',money(now)],['#finPrice',money(TIERS_()[0].price)],
   ['#pxNow',money(t.price)],['#tWas',money(was)],['#pxWas',money(t.was)],
   ['#sNow',money(t.price)],['#sWas',money(t.was)]].forEach(function(p){
    var el=$(p[0]); if(el) el.textContent=p[1];
  });
  [['#pxSave',saveAmt?'Save '+money(saveAmt):''],
   ['#sWas',t.was?money(t.was):'']].forEach(function(p){
    var el=$(p[0]); if(el){ el.textContent=p[1]; el.hidden=!p[1]; }
  });
  var sv=$('#tSaved');
  if(sv) sv.textContent="You're saving "+money(was-now)+" today";
  /* The gift-progress message lives in the CART, not the buy box — that is where
     the trimmer page puts it (drawer__ship / #dGiftMsg). The dashed box that used
     to sit under the bundles has been removed; unlockMsg() still feeds the
     drawer. */
  /* sticky bar + quick-add thumbnails track the selected colourway */
  /* On the theme there is no img/hero.jpg — use the model's first Shopify media,
     falling back to the local file only when running the prototype. */
  var heroSrc=(CO().mediaList && CO().mediaList.length && CO().mediaList[0].src) || (CO().dir+'hero.jpg');
  $$('.gf-colimg').forEach(function(im){ im.src=heroSrc; });
  if($('#dBody')) drawRender();
}

/* ── specs table ───────────────────────────────────────────────────────── */
var sg=$('#specgrid');
function drawSpecs(){
  if(!sg) return;
  sg.innerHTML=
   '<div class="spec spec--big"><span class="spec__k">Torque rating</span>'+
     '<span class="spec__v">'+SPEC.torqueNm+' Nm</span>'+
     '<span class="spec__n">'+SPEC.torqueFt+' ft-lb. An access tool, not a breaker bar — and we print it.</span></div>'+
   '<div class="spec spec--big"><span class="spec__k">Thickness</span>'+
     '<span class="spec__v">'+SPEC.thickIn+'"</span>'+
     '<span class="spec__n">'+SPEC.thickMm+' mm. Slimmer than the ratchet that won\'t fit.</span></div>'+
   [['Drive',SPEC.drive],
    ['Mechanism',SPEC.mechanism],
    ['Finish',SPEC.finish],
    ['Adapters in the box',CO().adapters+'-piece set'],
    ['Adapter steel',SPEC.adapterSteel],
    ['Hand tools only','No impact guns'],
    ['Returns',SPEC.guarantee+' days, money back']
   ].map(function(r){
     return '<div class="spec"><span class="spec__k">'+r[0]+'</span><span class="spec__v">'+r[1]+'</span></div>';
   }).join('');
}

/* ── FAQ — the ranked objection list, answered ─────────────────────────── */
function FAQ_(){ return [
  ['Is this going to bend or snap like the cheap ones?',
   'Fair question in this category, and the answer is a number instead of an adjective: '+TQ+'. '+
   'Under that it does its job. Over it, no tool of this design survives, ours included — which is '+
   'why the figure is printed on the page, on the box and in the ads instead of buried. The drive is '+
   'a sealed steel roller chain, not a plastic gear train, and the cutaway above shows you the inside '+
   'of it. If it does fail, the Lifetime Warranty add-on at the bottom of the buy box replaces it.'],

  ['Do I need my own ratchet, or does this turn on its own?',
   'You need your own, and it is worth being clear about because the photos can read either way. '+
   'This is not a powered tool and it has no handle of its own. You clip your ratchet, breaker bar or '+
   'wrench onto the '+SPEC.drive+' drive at the top, the chain carries that rotation down to the '+
   'socket on the bolt, and you turn. That is the whole point: your hand and your ratchet stay out '+
   'where there is room to swing them.'],

  ['I already own a breaker bar and an impact. Why do I need this?',
   'You do not, for the jobs those already do. A breaker bar has the power but needs roughly a foot '+
   'of clearance to swing. This is for the bolt where that clearance does not exist. Crack a seized '+
   'fastener loose with the breaker bar, then run it out with this in a space that has no swing room. '+
   'They work together — this goes next to the tools you own, it does not replace them.'],

  ['Can I run it with an impact gun?',
   'No. It is a '+SPEC.torqueFt+' ft-lb hand tool and an impact will destroy it. We would rather tell '+
   'you that here than replace it later. Hand tools only — ratchet, breaker bar, wrench.'],

  ['Will it break a rusted, seized bolt loose?',
   'Not on its own, and we will not claim it will. At '+SPEC.torqueFt+' ft-lb this is an access tool, '+
   'not a breaker bar. Break it loose first with the bar you already own, then use this to turn it out. '+
   'Anyone selling you a tool this slim as a bolt-breaker is setting you up to snap it.'],

  ['Is it really thinner than a ratchet? Because that is the whole problem.',
   'It is '+SPEC.thickIn+' inches — '+SPEC.thickMm+' mm — through the head. That is the number that '+
   'decides whether it goes in the gap at all, so it is on the page and on the box. And the honest '+
   'half: if your gap is narrower than '+SPEC.thickMm+' mm, this will not fit either. We would rather '+
   'you knew that now than found out on your back in the driveway.'],

  ['Will it fit my sockets?',
   'It is a '+SPEC.drive+' drive and it ships with a '+CO().adapters+'-piece chrome vanadium adapter '+
   'set, so it steps up and down to the common drive sizes rather than needing a matched socket. Each '+
   'adapter has its size stamped on it, and they are photographed in the gallery above — worth a look '+
   'before you order if you run an unusual drive, because we would rather you checked than guessed.'],

  ['Can I just buy a cheaper one on Amazon?',
   'You can buy a similar-looking one cheaper, yes. This is a known category, not a secret, and we are '+
   'not going to pretend otherwise. Here is the difference, and you can check it yourself in about two '+
   'minutes: go read those listings and try to find out what the tool is actually rated for. The ones '+
   'that print a torque figure at all tend to print a different one in the spec table than in the '+
   'bullet points, and the ones that do not print one are the reason every review section in this '+
   'category has the same complaint about the second time it got used. We publish '+TQ+', the '+
   'thickness, and what it is not for, in one place, and we would rather lose the sale to the cheap '+
   'one than take it by hiding the number.'],

  ['What comes in the box?',
   'The wrench, the '+CO().adapters+'-piece adapter set, and the retail box it ships in. Nothing you '+
   'have to buy separately to make it work.'],

  ['What if it fails a year from now?',
   'That is what the Lifetime Warranty add-on covers — $4.99 at the bottom of the buy box, and free '+
   'when you take the three-wrench bundle. If the tool ever fails, it gets replaced. Separate from '+
   'that, you have '+SPEC.guarantee+' days from delivery to send it back for your money back for any '+
   'reason at all.'],

  ['How fast does it ship, and what if I do not like it?',
   'Free shipping on every order, always — no minimum and no tier to reach. And you get '+
   SPEC.guarantee+' days to decide: if it is not the tool for your job, send it back for your money '+
   'back. Two full months is deliberate. This is a tool you buy before you need it, so it may well sit '+
   'in the box until the job that needs it turns up.']
];}
var fl=$('#faqList');
function drawFaq(){
  if(!fl) return;
  var FAQ=FAQ_();
  fl.innerHTML=FAQ.map(function(x){
    return '<div class="faq__i"><button class="faq__q" type="button" aria-expanded="false">'+
      x[0]+'<i>+</i></button><div class="faq__a"><p>'+x[1]+'</p></div></div>';
  }).join('');
  $$('.faq__q',fl).forEach(function(q){
    q.addEventListener('click',function(){
      var i=q.parentNode, open=i.classList.contains('on');
      i.classList.toggle('on',!open); q.setAttribute('aria-expanded',String(!open));
    });
  });
}

/* ── video row ──────────────────────────────────────────────────────────
   CAPTIONS DESCRIBE ONLY WHAT IS ON SCREEN. They make no claim about torque, speed
   or outcome, because I cannot verify any of that from footage — and two of these
   clips contradict the page's "hand tools only" line, which is Julian's to resolve.
   Rewrite them once he confirms what each clip is actually demonstrating.        */
var VIDEOS=[
  {f:'machine', cap:'On the job, on a machine',            sound:true},
  {f:'vise',    cap:'Clamped in a vise on the bench',      sound:true},
  {f:'demo',    cap:'The head and the drive, up close',    sound:false}
];
/* On the theme the local vid/*.mp4 files do not exist. Until all three clips are
   uploaded to Shopify (which transcodes them — his first upload already produced
   480p/720p/1080p renditions), fall back to whatever videos ARE in the product
   media rather than rendering three dead boxes. */
if(CFG && CFG.models){
  /* Every video on either product, de-duplicated by url, in media order. The
     captions stay positional and describe only what is on screen. */
  var themeVids=[], seen={};
  ['silver','orange'].forEach(function(k){
    ((CFG.models[k]||{}).media||[]).forEach(function(m){
      if(m.t!=='vid' || seen[m.src]) return;
      seen[m.src]=1;
      themeVids.push({url:m.src, poster:m.poster, sound:true});
    });
  });
  var CAPS=['On the job, on a machine','Clamped in a vise on the bench',
            'The head and the drive, up close'];
  VIDEOS = themeVids.map(function(v,i){
    return {url:v.url, poster:v.poster, cap:CAPS[i]||'', sound:true};
  });
}
var vr=$('#vids');
if(vr){
  vr.innerHTML=VIDEOS.map(function(v){
    return '<div class="vid" data-f="'+(v.f||('v'+VIDEOS.indexOf(v)))+'">'+
      '<video src="'+(v.url||('vid/'+v.f+'.mp4'))+'" poster="'+(v.poster||('vid/poster-'+v.f+'.jpg'))+'" '+
        'muted loop playsinline preload="none" disablepictureinpicture></video>'+
      (v.sound?'<button class="vid__snd" type="button" aria-pressed="false" '+
        'aria-label="Turn sound on">🔇</button>':'')+
      '<div class="vid__cap">'+v.cap+'</div></div>';
  }).join('');

  /* Play only what is on screen. Three autoplaying clips at once burns battery and
     data for no benefit, and preload="none" means nothing is fetched until we ask. */
  var vids=$$('#vids video');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        var el=e.target;
        if(e.isIntersecting){
          if(!el.dataset.loaded){ el.load(); el.dataset.loaded='1'; }
          var p=el.play(); if(p&&p.catch) p.catch(function(){});   /* autoplay may be refused */
        } else { el.pause(); }
      });
    },{threshold:0.35});
    vids.forEach(function(el){io.observe(el)});
  } else {
    /* no IO: load and play them rather than showing three dead posters */
    vids.forEach(function(el){el.load();var p=el.play();if(p&&p.catch)p.catch(function(){});});
  }
  /* tap the poster to play if the browser refused autoplay */
  vids.forEach(function(el){
    el.addEventListener('click',function(){
      if(el.paused){ if(!el.dataset.loaded){el.load();el.dataset.loaded='1';} el.play().catch(function(){}); }
      else el.pause();
    });
  });
  /* unmute toggle — only one clip audible at a time */
  $$('.vid__snd').forEach(function(b){
    b.addEventListener('click',function(e){
      e.stopPropagation();
      var el=b.parentNode.querySelector('video'), on=el.muted;
      vids.forEach(function(o){o.muted=true;});
      $$('.vid__snd').forEach(function(o){o.textContent='🔇';o.setAttribute('aria-pressed','false');
        o.setAttribute('aria-label','Turn sound on');});
      if(on){ el.muted=false; b.textContent='🔊'; b.setAttribute('aria-pressed','true');
              b.setAttribute('aria-label','Turn sound off');
              if(el.paused) el.play().catch(function(){}); }
    });
  });
}

/* ── promo countdown ───────────────────────────────────────────────────── */
var END=Date.now()+1000*60*38;
function tick(){
  var d=Math.max(0,END-Date.now()),
      h=Math.floor(d/3.6e6), m=Math.floor(d%3.6e6/6e4), s=Math.floor(d%6e4/1000),
      p=function(n){return String(n).padStart(2,'0')};
  var a=$('#c-h'),b=$('#c-m'),c=$('#c-s');
  if(a)a.textContent=p(h); if(b)b.textContent=p(m); if(c)c.textContent=p(s);
}
tick(); setInterval(tick,1000);

/* ── in-page scroll ────────────────────────────────────────────────────── */
$$('[data-scroll]').forEach(function(el){
  el.addEventListener('click',function(){
    var t=document.querySelector(el.dataset.scroll);
    if(t) t.scrollIntoView({behavior:'smooth',block:'start'});
  });
});

/* ══ CART WIRING ══════════════════════════════════════════════════════════
   The Shopify product now exists: "GripForge™ Offset Extension Wrench",
   product 9408717488382, handle gripforge-offset-extension-wrench.
   It is a DRAFT — invisible on the storefront until Julian publishes it, so
   /cart/add.js will 422 until he does. That is deliberate: creating a draft
   touches nothing live and is fully reversible.

   THREE REAL PACK VARIANTS, each added as ONE line of quantity 1 — never one
   variant at quantity 1/2/3. This is the lesson from the Silver handle:
   Kaching's quantity bars are Shopify Functions and are NOT scoped per
   product, and two live deals are currently scoped to "All products". A line
   of quantity 2 would get repriced by the trimmer's 2-for bar and the shopper
   would be billed something other than what this page shows. A line of
   quantity 1 never trips those bars, so Shopify owns the price and the page
   can never disagree with checkout.                                         */
/* ══ SHOPIFY VARIANTS ═════════════════════════════════════════════════════
   Julian restructured this in Shopify on 2026-08-10 into TWO SEPARATE PRODUCTS,
   one per model, each with a Pack option. That is a better shape than my single
   product with a Model option, because the order line then names the model on
   its own line and the supplier reads it without decoding a variant title.

   Offset Extension Max — product 9409309180158, handle offset-extension-max
   Offset Extension 2.0 — product 9408717488382, handle gripforge-offset-extension-wrench

   Every add is still ONE line of quantity 1 against a real pack variant, so
   Kaching's All-products quantity bars can never reprice it.

   SKUs are deliberately self-describing for fulfilment: GF-MAX-X2 = Max, two
   wrenches. Each variant also carries its own image, so the packing slip shows
   the tool that was actually ordered rather than a generic product photo.      */
var VARIANT={
  /* Max: $99.99 / $144.99 / $194.99 — SKU GF-MAX-X1..X3 */
  silver:{1:48707394044158, 2:48707437789438, 3:48707437822206},
  /* 2.0: $69.99 / $99.99  / $139.99 — SKU GF-V20-X1..X3 */
  orange:{1:48703439732990, 2:48707439001854, 3:48707439034622},
  prot:48089577554174,   // Shipping Protection $3.99 — already live
  wty :48090564624638    // Lifetime Warranty $4.99 — already live
};
applyCFG();   /* must come AFTER VARIANT is assigned — see the note above */
function desiredLines(){
  var packs=VARIANT[state.color]||{};
  var o=[{id:packs[state.tier]||0,quantity:1}];
  /* Never charge for an add-on the selected tier already gave away free. The
     bundle card promises it; billing for it anyway is the page disagreeing with
     the cart, which is the exact failure the Silver pricing taught us about. */
  if(state.prot && !isFree('prot')) o.push({id:VARIANT.prot,quantity:1});
  if(state.wty  && !isFree('wty'))  o.push({id:VARIANT.wty, quantity:1});
  return o;
}
/* On the theme this is true, so ATC posts to the real /cart.js. On localhost it
   is false and the button explains itself instead of failing silently. */
var LIVE=/gripforgeshop\.com|\.myshopify\.com|shopifypreview\.com/.test(location.hostname);

/* ══ META / SHOPIFY EVENT TRACKING ════════════════════════════════════════
   Shopify's Meta integration maps its own customer events to Meta standard
   events: checkout_started -> InitiateCheckout and checkout_completed ->
   Purchase both happen on Shopify's OWN checkout and order-status pages, so
   those two already work and this file must not re-fire them blindly or they
   double-count.

   AddToCart is the real gap: this page adds via fetch('/cart/add.js') rather
   than a Shopify product form, so nothing here is guaranteed to emit
   product_added_to_cart. So we publish the Shopify customer event, which feeds
   Shopify analytics AND every connected pixel — including Meta via the official
   channel with server-side CAPI — through ONE path.

   ⚠ FIXED 2026-08-10: this used to ALSO call fbq('track','AddToCart') directly
   as a "belt and braces" path, on the theory that passing the same eventID to
   both would make Meta collapse them. It does not. Shopify's web pixel builds
   its own payload with its own event ID when it forwards product_added_to_cart,
   so the eventId passed to Shopify.analytics.publish never reaches Meta and the
   two events do NOT dedup. Verified on the live page: one add produced both
   fbq('track','AddToCart', …) from here and fbq('trackShopify', <pixel>,
   'AddToCart') from Shopify's sandbox — i.e. AddToCart counted twice, which
   inflates the number the ad account optimises against.
   Same reasoning for InitiateCheckout, which Shopify already fires from
   checkout_started on its own checkout page — exactly as the paragraph above
   says, though the code had been re-firing it anyway.
   One event, one source. If Meta ever shows ZERO AddToCart, the Shopify ->
   Meta channel is the thing to check, not this file.                          */
function evId(kind, lines){
  return kind+'-'+lines.map(function(l){return l.id}).join('-')+'-'+Math.floor(Date.now()/1000);
}
function lineValue(lines){
  var t=T(), v=0;
  lines.forEach(function(l){
    if(l.id===VARIANT.prot) v+=PROT;
    else if(l.id===VARIANT.wty) v+=WTY;
    else v+=t.price;
  });
  return Math.round(v*100)/100;
}
function trackAddToCart(lines){
  var value=lineValue(lines), ids=lines.map(function(l){return String(l.id)}), id=evId('atc',lines);
  try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish)
    Shopify.analytics.publish('product_added_to_cart',
      {variantIds:ids, value:value, currency:'USD', eventId:id}); }catch(e){}
}
function trackInitiateCheckout(lines){
  /* Deliberately a no-op for Meta. Shopify fires checkout_started on its own
     checkout page, which the Meta channel maps to InitiateCheckout. Re-firing it
     from here counted it twice. Kept as a function so the call sites stay honest
     about where the event happens. */
}
var atc=$('#atc');
if(atc) atc.addEventListener('click',function(e){
  e.preventDefault();
  var lines=desiredLines();
  state.added=true; drawTotal();
  if(!LIVE){
    alert('Local prototype — the Shopify cart is a different origin, so this button\n'+
          'cannot post from localhost.\n\nIt IS wired. On the storefront it would add:\n\n'+
          lines.map(function(l){return '  variant '+l.id+' x'+l.quantity}).join('\n')+
          '\n\nThe product is a DRAFT (id 9408717488382) — publish it in Shopify and\n'+
          'this works exactly like the trimmer page.');
    return;
  }
  atc.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:lines})})
   .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||r.status)}); return r.json(); })
   .then(function(){
     atc.disabled=false;
     trackAddToCart(lines);
     state.added=true;
     /* Open OUR drawer. Redirecting to /cart handed the shopper the theme's
        default cart page — different design, no upsells, no gift progress —
        which is the page this drawer exists to replace. */
     return syncFromShopifyCart().then(function(){ drawRender(); openCart(); });
   })
   .catch(function(err){ atc.disabled=false; alert('Could not add to cart: '+err.message); });
});

/* ══ STICKY BAR ═══════════════════════════════════════════════════════════
   Same trigger as the trimmer: show it once the buy box has scrolled out of
   view and we are more than 600px down. This is what keeps the price on screen
   on mobile after the buy box is gone.                                       */
var sticky=$('#sticky'), buyEl=$('.buy');
function syncSticky(){
  if(!sticky||!buyEl) return;
  var b=buyEl.getBoundingClientRect();
  var past=b.bottom<=0||b.top>=innerHeight;      /* buy box out of view */
  sticky.classList.toggle('on', past && scrollY>600);
}
if(sticky&&buyEl){
  /* IntersectionObserver is the cheap path, but a passive scroll listener is
     the fallback: if IO never fires — throttled tab, background render — the
     bar would otherwise never appear and the price would vanish on scroll,
     which is the whole reason this bar exists. Both call one function. */
  if('IntersectionObserver' in window){
    new IntersectionObserver(syncSticky,{threshold:0}).observe(buyEl);
  }
  addEventListener('scroll',syncSticky,{passive:true});
  addEventListener('resize',syncSticky,{passive:true});
  syncSticky();
}
var sAtc=$('#stickyAtc');
if(sAtc) sAtc.addEventListener('click',function(){ atc&&atc.click(); });

/* ══ CART DRAWER ══════════════════════════════════════════════════════════
   Renders from local state, because a localhost page cannot read Shopify's
   /cart.js across origins. On the live theme this same render runs off the
   /cart.js payload; the markup and every class are the trimmer's.           */
var drawer=$('#drawer'), scrim=$('#scrim');

/* Scroll-lock ONLY below 980px. Above it the gallery column is position:sticky,
   and overflow:hidden on an ancestor silently kills sticky — which made the
   desktop hero go blank on the trimmer page twice before this guard existed. */
var LOCK_BELOW=980;
function lockScroll(on){
  document.body.style.overflow=(on&&innerWidth<=LOCK_BELOW)?'hidden':'';
}
function openCart(){ if(!drawer)return; drawRender(); drawer.classList.add('on');
  scrim.classList.add('on'); lockScroll(true); }
function closeCart(){ if(!drawer)return; drawer.classList.remove('on');
  scrim.classList.remove('on'); lockScroll(false); }
['#openCart'].forEach(function(s){var e=$(s); if(e) e.addEventListener('click',openCart);});
var cc=$('#closeCart'); if(cc) cc.addEventListener('click',closeCart);
if(scrim) scrim.addEventListener('click',closeCart);
addEventListener('keydown',function(e){ if(e.key==='Escape') closeCart(); });

/* Read the real cart back after adding so the drawer shows what Shopify actually
   holds — including items added on an earlier visit — not just what this page's
   buy box configured. */
var SHOPCART=null;
function syncFromShopifyCart(){
  if(!LIVE) return Promise.resolve();
  return fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json()})
    .then(function(c){ SHOPCART=c; })
    .catch(function(){ SHOPCART=null; });
}
/* Which pack tier a variant id is, for either model. Empty for add-ons and for
   anything else that ended up in the cart. */
function packInfo(id){
  var out=null;
  ['silver','orange'].forEach(function(k){
    var P=VARIANT[k]||{};
    [1,2,3].forEach(function(q){ if(P[q]===id) out={model:k,q:q,packs:P}; });
  });
  return out;
}
function cartLines(){
  if(SHOPCART && SHOPCART.items && SHOPCART.items.length){
    /* The wrench leads. Shopify returns lines in its own order, which put
       "Shipping Protection $3.99" above the $144.99 wrench whenever the add-on
       variant had been in the cart more recently — so the first thing in the
       drawer was a $3.99 accessory instead of the product being bought.
       Sort packs first, then add-ons, and keep Shopify's own order within each
       group. NOTE: .line must stay the ORIGINAL 1-based index, because
       /cart/change.js addresses lines by position in Shopify's array, not ours. */
    return SHOPCART.items.map(function(i,ix){
      return {img:i.image||((MEDIA[0]||{}).src),
              n:i.product_title,
              s:(i.variant_title&&i.variant_title!=='Default Title')?i.variant_title:'',
              p:i.line_price/100,
              was:(i.original_line_price>i.line_price)?i.original_line_price/100:0,
              line:ix+1,          /* /cart/change.js is 1-indexed */
              qty:i.quantity,
              vid:i.variant_id,
              pack:packInfo(i.variant_id),
              live:true};
    }).sort(function(a,b){
      var ap=a.pack?0:1, bp=b.pack?0:1;
      return ap!==bp ? ap-bp : a.line-b.line;   /* stable within each group */
    });
  }
  /* name the MODEL the shopper picked, not the generic tier name, so the drawer
     line matches the Shopify variant title exactly */
  var t=T(), o=[{img:(MEDIA[0]||{}).src||CO().dir+'hero.jpg',
                 n:CO().name, s:t.q+' × wrench · '+t.each,
                 p:t.price, was:t.was}];
  if(state.prot&&!isFree('prot')) o.push({img:IMG_PROT,n:'Shipping Protection',
    s:'Loss, theft & damage',p:PROT,was:0});
  if(state.wty&&!isFree('wty')) o.push({img:IMG_WTY,n:'Lifetime Warranty',
    s:'Free replacement if it ever fails',p:WTY,was:0});
  t.gifts.forEach(function(g){ o.push({img:g.img,n:g.t,s:'Included with this bundle',p:0,was:0,gift:true}); });
  return o;
}

function drawRender(){
  var t=T(), lines=cartLines();
  var body=$('#dBody');
  if(body) body.innerHTML=lines.map(function(l){
    /* Real Shopify lines get the trimmer's exact control set: a quantity stepper
       where the minus turns into a DELETE at qty 1, so any line can be removed —
       including the wrench itself, which is what lets someone buy protection or
       the warranty alone if they want to. Gift lines and the prototype's
       synthetic lines get no controls, because there is nothing to change. */
    var ctl='';
    if(l.live && l.pack){
      /* ⚠ A PACK LINE'S STEPPER WALKS THE PACK TIERS. It must never raise the
         quantity, because Kaching's "Two GripForge™ Handle Bundle" deal is scoped
         to All products and fires on a LINE quantity of 2 — verified 2026-08-11:
         two 2-packs ($289.98) got discounted by $219.99 down to $69.99, i.e. four
         wrenches for the price of one. This is the same reason the trimmer's own
         stepper "walks the bundle tiers" rather than incrementing.
         So: + moves 1 Wrench -> 2 Wrenches -> 3 Wrenches by SWAPPING the variant,
         − steps back down, and at the 1-pack it becomes a delete. The number is
         shown read-only so nobody can type their way into a quantity of 2.      */
      var P=l.pack.packs, q=l.pack.q;
      ctl='<span class="qty">'+
        (q<=1
          ? '<button type="button" class="qty-del" data-line="'+l.line+'" data-q="0" '+
            'aria-label="Remove '+l.n+' from cart" title="Remove">'+TRASH+'</button>'
          : '<button type="button" data-swap="'+l.vid+'" data-to="'+P[q-1]+'" aria-label="Fewer wrenches">−</button>')+
        '<b>'+q+'</b>'+
        '<button type="button" data-swap="'+l.vid+'" data-to="'+(P[q+1]||'')+'" '+
          'aria-label="More wrenches"'+(P[q+1]?'':' disabled')+'>+</button>'+
      '</span>'+
      '<button type="button" class="ci-rm" data-line="'+l.line+'" data-q="0">Remove</button>';
    } else if(l.live){
      /* add-ons and anything else: delete only. Nobody needs two shipping
         protections, and a quantity of 2 on any line is Kaching-exposed. */
      ctl='<span class="qty">'+
        '<button type="button" class="qty-del" data-line="'+l.line+'" data-q="0" '+
          'aria-label="Remove '+l.n+' from cart" title="Remove">'+TRASH+'</button>'+
        '<b>'+l.qty+'</b></span>'+
        '<button type="button" class="ci-rm" data-line="'+l.line+'" data-q="0">Remove</button>';
    }
    return '<div class="ci"><img src="'+l.img+'" alt="">'+
      '<span class="n">'+l.n+(l.s?'<small>'+l.s+'</small>':'')+ctl+'</span>'+
      '<span class="p">'+(l.gift?'FREE':money(l.p))+
        (l.was?'<s>'+money(l.was)+'</s>':'')+'</span></div>';
  }).join('')||'<p class="dempty">Your cart is empty.</p>';

  /* one handler for every control; Shopify's cart is not safe against
     overlapping writes, so the whole drawer locks while a change is in flight */
  $$('#dBody [data-line]').forEach(function(b){
    b.addEventListener('click',function(){ changeLine(+b.dataset.line, +b.dataset.q); });
  });
  $$('#dBody [data-swap]').forEach(function(b){
    b.addEventListener('click',function(){
      if(b.disabled) return;
      swapPack(+b.dataset.swap, +b.dataset.to);
    });
  });

  /* gift progress — a REAL gate (gifts), never a free-shipping one */
  var fill=$('#dGiftFill'), msg=$('#dGiftMsg');
  if(fill) fill.style.width=Math.round(t.q/3*100)+'%';
  if(msg) msg.innerHTML=unlockMsg();
  var d1=$('#dTier1'), d2=$('#dTier2');
  if(d1) d1.classList.toggle('hit',t.q>=2);
  if(d2) d2.classList.toggle('hit',t.q>=3);

  /* quick-add walks up a tier
     ⚠ FIXED 2026-08-10 (found on the LIVE site): this used to just set
     state.tier and redraw. But drawTotal() below re-reads the total from
     SHOPCART, so the server value immediately overwrote it and the button did
     NOTHING — a dead "+$50.00 · unlocks 2 free gifts" upsell sitting in the
     cart. It only ever "worked" in the local prototype, where there is no
     server cart to overwrite it.
     When the cart is live it must act on the CART's pack line, and it must walk
     tiers by SWAPPING the variant for the same Kaching reason as the stepper. */
  var qa=$('#dAddWrench');
  if(qa){
    var lp=lines.filter(function(l){return l.live && l.pack})[0];
    var curQ  = lp ? lp.pack.q : t.q;
    var nextV = lp ? lp.pack.packs[curQ+1] : null;
    if(curQ>=3 || (LIVE && lp && !nextV)){ qa.style.display='none'; }
    else{
      qa.style.display='';
      var nxt=TIERS_()[curQ];
      $('#dAddPx').textContent='+'+money(nxt.price-(lp?lp.p:t.price));
      $('#dAddSub').textContent=curQ===1?'Unlocks 2 free gifts':'Unlocks the Lifetime Warranty + the guide';
      qa.onclick=function(){
        if(LIVE && lp && nextV){ swapPack(lp.vid, nextV); return; }
        state.tier=curQ+1; drawBundles(); drawAddons(); drawTotal(); drawRender();
      };
    }
  }

  /* the two paid add-ons, in the drawer this time */
  var da=$('#dAddons');
  if(da){
    da.innerHTML=UPSELL.map(function(u){
      var free=isFree(u.key), on=free||state[u.key];
      return '<button class="addon addon--cart" data-k="'+u.key+'" data-on="'+(on?1:0)+'" type="button"'+
        (free?' disabled aria-disabled="true"':'')+'>'+
        '<img src="'+u.img+'" alt="">'+
        '<span class="a-t">'+u.n+' <small>'+u.s+'</small></span>'+
        '<span class="a-p">'+(free?'<b class="a-free">FREE</b>':'+'+money(u.p))+'</span>'+
        '<span class="chk" role="checkbox" aria-checked="'+(on?'true':'false')+'">✓</span></button>';
    }).join('');
    $$('.addon',da).forEach(function(el){
      if(el.disabled) return;
      el.addEventListener('click',function(){
        /* ⚠ was: state[k]=!state[k] and redraw — see setAddon() for why that
           silently charged the shopper nothing while ticking the box on. */
        setAddon(el.dataset.k, !state[el.dataset.k]);
      });
    });
  }

  var sub=lines.reduce(function(a,l){return a+l.p},0);
  var wasTot=lines.reduce(function(a,l){return a+(l.was||l.p)},0);
  if(SHOPCART && SHOPCART.items){ sub=SHOPCART.total_price/100;
    wasTot=(SHOPCART.items_subtotal_price||SHOPCART.total_price)/100; }
  var n=$('#dTotal'); if(n) n.textContent=money(sub);
  var sv=$('#dSave'); if(sv) sv.textContent='–'+money(Math.max(0,wasTot-sub));
  var count=(SHOPCART&&SHOPCART.item_count!=null)?SHOPCART.item_count:t.q;
  var ct=$('#dCount'); if(ct) ct.textContent=count+(count===1?' item':' items');
  /* The header badge counts what is actually IN the cart, not what the buy box
     happens to be configuring — otherwise a fresh page load reads "CART 1"
     before the shopper has added anything, which is just untrue. The drawer
     itself previews the configured order, which is what makes it useful here. */
  var hc=$('#cartCount');
  if(hc) hc.textContent=(SHOPCART&&SHOPCART.item_count!=null)?SHOPCART.item_count:(state.added?t.q:0);
}
/* quantity / delete against the REAL cart */
var cartBusy=false;
function changeLine(line, qty){
  if(cartBusy || !LIVE) {
    if(!LIVE) alert('Local prototype — cart edits need the Shopify cart, so try this on the theme preview.');
    return;
  }
  cartBusy=true;
  var d=$('#drawer'); if(d) d.setAttribute('aria-busy','true');
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({line:line, quantity:qty})})
   .then(function(r){return r.json()})
   .then(function(c){ SHOPCART=c; })
   .catch(function(){ /* leave the old view rather than blanking the drawer */ })
   .then(function(){
     cartBusy=false;
     if(d) d.removeAttribute('aria-busy');
     var hc=$('#cartCount');
     if(hc && SHOPCART) hc.textContent=SHOPCART.item_count||0;
     drawRender();
   });
}

/* Swap one pack variant for another in a single request. /cart/change.js cannot
   change a variant, but /cart/update.js takes absolute quantities keyed by
   variant id, so old->0 and new->1 happens atomically. */
function swapPack(oldId, newId){
  if(cartBusy || !LIVE || !newId) return;
  cartBusy=true;
  var d=$('#drawer'); if(d) d.setAttribute('aria-busy','true');
  var u={}; u[oldId]=0; u[newId]=1;
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({updates:u})})
   .then(function(r){return r.json()})
   .then(function(c){
     SHOPCART=c;
     /* keep the buy box in step with what the cart now holds */
     var pi=packInfo(newId);
     if(pi){ state.color=pi.model; state.tier=pi.q;
       drawColors(); drawGallery(0); drawBundles(); drawAddons(); drawSpecs(); drawFaq(); drawTotal(); }
   })
   .catch(function(){})
   .then(function(){
     cartBusy=false;
     if(d) d.removeAttribute('aria-busy');
     var hc=$('#cartCount'); if(hc && SHOPCART) hc.textContent=SHOPCART.item_count||0;
     drawRender();
   });
}

/* An add-on toggled INSIDE the drawer has to reach the REAL cart.
   ⚠ FIXED 2026-08-10 (found on the LIVE site): this used to flip local state and
   redraw, but drawTotal() re-reads the total from SHOPCART, so the row ticked ON,
   the price never moved, and nothing was ever added. Losing the $3.99 is the
   small half — the cart was telling the shopper they had shipping protection
   they had not bought, which support would have had to unpick after a lost
   parcel. Same class of bug as the pack stepper: local state is not the cart. */
function setAddon(key, want){
  if(cartBusy) return;
  var vid=VARIANT[key];
  if(!LIVE || !vid){ state[key]=want; drawAddons(); drawTotal(); drawRender(); return; }
  cartBusy=true;
  var d=$('#drawer'); if(d) d.setAttribute('aria-busy','true');
  var u={}; u[vid]=want?1:0;   /* absolute quantity — never an increment */
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({updates:u})})
   .then(function(r){return r.json()})
   .then(function(c){ SHOPCART=c; state[key]=want; drawAddons(); drawTotal(); })
   .catch(function(){})
   .then(function(){
     cartBusy=false;
     if(d) d.removeAttribute('aria-busy');
     var hc=$('#cartCount'); if(hc && SHOPCART) hc.textContent=SHOPCART.item_count||0;
     drawRender();
   });
}

var dck=$('#dCheckout');
if(dck) dck.addEventListener('click',function(){
  if(!LIVE){ closeCart(); atc&&atc.click(); return; }
  trackInitiateCheckout(desiredLines());
  location.href='/checkout';
});

/* ── wallet buttons ──────────────────────────────────────────────────────
   RESTORED 2026-08-11: these handlers were silently dropped in an earlier
   refactor, so Shop Pay / Apple Pay / Google Pay / PayPal and "More payment
   options" all rendered and did NOTHING. I had only ever tested that the four
   buttons existed, never that clicking one did anything — existence is not
   behaviour, and that is the second time that distinction has bitten on this
   page.
   On the live theme these add to the cart, fire InitiateCheckout, then hand off
   to Shopify's checkout, where its own accelerated-payment buttons take over. */
$$('#buyNow,[data-wallet],#moreOpts').forEach(function(w){
  w.addEventListener('click',function(e){
    e.preventDefault();
    if(!LIVE){ atc&&atc.click(); return; }
    var lines=desiredLines();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:lines})})
     .then(function(){ trackAddToCart(lines); trackInitiateCheckout(lines);
                       location.href='/checkout'; })
     .catch(function(){ location.href='/cart'; });
  });
});



drawColors(); drawGallery(0); drawBundles(); drawAddons();
drawSpecs(); drawFaq(); drawTotal(); drawRender();
})();
